import { useQuery } from 'react-query';
import { useResourcesApi } from 'services/api';

export const useFetchEntityTypes = () => {
    const { getPushApiEntityTypes } = useResourcesApi();
    const { data, isLoading, isError } = useQuery(
        'entityTypes',
        async () => {
            const data = await getPushApiEntityTypes();

            return data.map(item => ({
                value: item.name,
                label: item.value,
            }));
        },
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        }
    );
    return { data, isLoading, isError };
};
